import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import ApplicationTeachersAid from '../components/ApplicationTeachersAid';
import EducatorApplicationStartPage from '../pages/EducatorApplicationStartPage';
import EducatorAccountPage from '../pages/EducatorAccountPage';

const TeachersAidEducatorRoutes = ({ match, user }) => {
  const { applicationTeachersAidRequired } = user;
  if (applicationTeachersAidRequired) {
    return (
      <Switch>
        <Switch>
          <AuthRoute path={`${match.path}/start`} component={EducatorApplicationStartPage} />
          <AuthRoute path={`${match.path}/application/:step?/:id?`} component={ApplicationTeachersAid} />
          <Route component={() => <Redirect to={`${match.path}/application`} />} />
        </Switch>
      </Switch>
    );
  }

  return (
    <Fragment>
      <Switch>
        <AuthRoute path={`${match.path}/account`} component={EducatorAccountPage} />
        <AuthRoute path={`${match.path}/application/:step?/:id?`} component={ApplicationTeachersAid} />
        <Route component={() => <Redirect to={`${match.path}/account/applications`} />} />
      </Switch>
    </Fragment>
  );
};

TeachersAidEducatorRoutes.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default TeachersAidEducatorRoutes;
